module.exports = __webpack_public_path__ + "media/components/messages/attachments/download-alert-ee74cbb65af000f7d8a3c08a25e2f9a3.svg";